import { render, staticRenderFns } from "./IntroManageDetail.vue?vue&type=template&id=a0a09522&scoped=true"
import script from "./IntroManageDetail.vue?vue&type=script&lang=ts"
export * from "./IntroManageDetail.vue?vue&type=script&lang=ts"
import style0 from "./IntroManageDetail.vue?vue&type=style&index=0&id=a0a09522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a09522",
  null
  
)

export default component.exports